import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS, CONTENT_ALIAS } from '../const.config';

// Categories module configurations
export const LISTING_COLUMNS = [
  {
    id: 'thumbnail',
    label: 'Image Preview',
    width: '5%',
    align: 'center',
    dataKey: 'thumbnail',
    sortable: false,
    type: CELL_DATA_TYPES.IMAGE,
  },
  {
    id: 'name',
    label: 'Name',
    width: '20%',
    align: 'left',
    dataKey: 'name',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    width: '15%',
    align: 'left',
    dataKey: 'description',
    sortable: false,
    type: CELL_DATA_TYPES.PRESENCE,
  },
  {
    id: 'totalEpisodes',
    label: 'Total Episodes',
    width: '15%',
    align: 'center',
    dataKey: 'totalEpisodes',
    sortable: false,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'categoryNumber',
    label: `${CONTENT_ALIAS.ASSIGN_CATEGORY}`,
    width: '10%',
    align: 'center',
    dataKey: 'categoryNumber',
    sortable: false,
    type: CELL_DATA_TYPES.POPUP_BUTTON,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.UPLOAD_IMAGE.value,
    label: ACTIONS.UPLOAD_IMAGE.label,
  },
  {
    action: ACTIONS.ASSIGN_CATEGORIES.value,
    label: ACTIONS.ASSIGN_CATEGORIES.label,
  },
  {
    action: ACTIONS.MANAGE_EPISODES.value,
    label: ACTIONS.MANAGE_EPISODES.label,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

export const VIEW_SHOWS_COLUMNS = [
  {
    id: 'name',
    label: 'Name',
    dataKey: 'name',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'year',
    label: 'Year',
    dataKey: 'year',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'rating',
    label: 'Rating',
    dataKey: 'rating',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'ageRestrict',
    label: 'Age Restrict',
    dataKey: 'ageRestrict',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'tags',
    label: 'Tags',
    dataKey: 'tags',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'totalEpisodes',
    label: 'Toatal Episodes',
    dataKey: 'totalEpisodes',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'categoryNumber',
    label: `${CONTENT_ALIAS.ASSIGN_CATEGORY}`,
    dataKey: 'categoryNumber',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'thumbnail',
    label: 'Thumbnail',
    dataKey: 'thumbnail',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    dataKey: 'modifiedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
